import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { environment } from "environments/environment";
import { retry, catchError, tap, finalize } from "rxjs/operators";
import { Injectable, Injector, inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";

import { UtilsService } from "@core/services/utils/utils.service";
import { MatDialog } from "@angular/material/dialog";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { BankProgressBarService } from "@core/components/progress-bar";
import { vGlobal } from "@core/types/cb-global-vars";
import { WebSocketService } from '@core/services/websocket/websocket.service';

@Injectable({ providedIn: "root" })
export class ApiService {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------
  @BlockUI() blockUI!: NgBlockUI;
  // ------------------------------------------------------------x-----------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private apiURL: string = environment.ipServer;
  private path: string = environment.app_path;

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _httpClient: HttpClient,
    private _injector: Injector,
    private _utilS: UtilsService,
    private _mStorage: manageStorageService,
    private _bankProgressBarService: BankProgressBarService,
    private _websocket: WebSocketService,
    private dialogRef: MatDialog // all windows
  ) {

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * [handleError]  Error handling
   * @param error
   */

  private handleError(error: any) {
    let
      errorMessage = {
        message:
          (error)
            ? error?.message
            : "",
        codeError: error?.codeError,
        wsName: error?.wsName,
        codeFiable: error?.codeFiable
      };

    return throwError(() => errorMessage);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * [send] send data to web service
   * @param keyService
   * @param dataSend
   */
  public poSt(
    keyService: string,
    dataSend: any
  ): Observable<HttpResponse<Object>> {
    return this._httpClient
      .post<HttpResponse<Object>>(
        `${this.apiURL}${this.path}${keyService}`,
        dataSend
      )
      .pipe(
        retry(0),
        tap((data) => {  /* console.info('server data:', data) */ }),
        catchError(this.handleError)
      );
  }
  /**
  * [gEt]
  * @param keyService 
  * @param qryParms 
  * @returns 
  */
  public gEt(keyService: string, qryParms: any = {}) {

    let reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' }),
      wsName = keyService.split("/").pop() || '',
      wsNOLoader = vGlobal.wsNoBlockUI.includes(wsName);

    if (!wsNOLoader) { this._bankProgressBarService.show(); this.blockUI.start(); }

    return this._httpClient.get(`${this.apiURL}${this.path}${keyService}`, {
      params: qryParms,
      observe: "response",
      headers: reqHeader
    })
      .pipe(
        retry(0),
        tap(),
        catchError(this.handleError),
        finalize(() => {
          if (!wsNOLoader) {
            this._bankProgressBarService.hide();
            this.blockUI.stop();
          }
        })
      )
  }
  /**
   * [send] send data to web service
   * @param keyService
   * @param dataSend
   */
  public pUt(
    keyService: string,
    dataSend: any
  ): Observable<HttpResponse<Object>> {
    return this._httpClient
      .put<HttpResponse<Object>>(
        `${this.apiURL}${this.path}${keyService}`,
        dataSend
      )
      .pipe(
        retry(0),
        tap((data) => {  /* console.info('server data:', data) */ }),
        catchError(this.handleError)
      );
  }

  /**
   * !geoRqst
   * @param dataSend ç
   * @returns 
   */
  public geoRqst(dataSend: any): Observable<HttpResponse<Object>> {
    return this._httpClient
      .post<HttpResponse<Object>>(
        `${this.apiURL}gfvpm-cb-geolocation-rest/api/geolocation/add`,
        dataSend
      )
      .pipe(
        retry(0),
        tap((data) => {  /* console.info('server data:', data) */ }),
        catchError(this.handleError)
      );
  }
  /**
   * [logOut]
   */
  public logOut(zone: string = "" )  {
    const router = this._injector.get(Router);

    if (zone == 'navigate') { router.navigate(["/sign-out"]); }
    else {
      let qryParms = { 'operacion': '916', "usuario": this._mStorage.getPropertie('s_userSession')?.principal, "cip": '', "nuevo": '', "sid": '' }
      return new Promise<boolean>((rslvUpdtState, rjctUpdtState) => {
        this.gEt("seguridad/v1/usr/session", qryParms,)
          .subscribe({
            next: (apiResultLogout: any) => {
              if (this._utilS.isEmpty(apiResultLogout)) { rjctUpdtState(false) }
              else {
                rslvUpdtState(true);
                this._websocket.disconnect();
                this._injector.get(manageStorageService).clearStorage("all");
                this.dialogRef.closeAll();
              }
            },
            error: (eRR) => rjctUpdtState(false)
          });
      });
    }
  }

}
